const voucher = state => state.voucher;
const voucherData = state => state.voucher.voucherData;
const error = state => state?.voucher?.error;
const applied = state => state?.voucher?.applied;
const createUserByVoucher = state => state?.voucher?.createUserByVoucher;

export { applied, error, voucher, voucherData, createUserByVoucher };
